import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig, guid } from '@datorama/akita';
import { FantasyHistory } from './models/fantasy-history.model';

export interface FantasyHistoryState extends EntityState<FantasyHistory> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'fantasy-history', idKey: 'UniqueIdentifier', cache: { ttl: 20000 }})
export class FantasyHistoryStore extends EntityStore<FantasyHistoryState> {

  constructor() {
    super();
  }

  akitaPreAddEntity(history: Readonly<FantasyHistory>) {
    if (!history.UniqueIdentifier) {
      return {
        ...history,
        UniqueIdentifier: guid()
      };
    }
    return history;
  }
}
